'use client';
import { useEffect } from 'react';
import { ErrorNotice } from '@/components/site/error-notice';

/** Route-level error boundary: keeps a failed action/render from blanking the
    whole app and offers the way home instead of the default Next.js error screen. */
export default function Error({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    console.error(error);
    // A purged JS chunk (stale tab after a redeploy, or a dev HMR miss) can't be
    // recovered by reset() — the chunk 404s forever. Hard-reload to fetch the new
    // bundle instead of looping on the error screen.
    if (/ChunkLoadError|Loading chunk [\d]+ failed|Failed to fetch dynamically imported module/i.test(error?.message ?? '')) {
      window.location.reload();
    }
  }, [error]);

  return <ErrorNotice />;
}
